import { login_login_user } from "../pages/auth/types/login";

const publicRoutes = ["/login", "/logout"];
const clientRoutes = ["/", "/moneyComments", "/orders", "/discounts", "/products", "/returnPurchases", "/defects"];

export default function hasPermission(
  user: login_login_user | undefined | null,
  path?: string
) {
  if (publicRoutes.includes(path || "")) return true;
  if (!user || (!user.id && !user.userName && !user.email)) return false;

  const userName = user?.userName?.toLowerCase() || "";

  // Counterparty foydalanuvchi uchun cheklangan yo'llar
  if (userName === "counterparty" || user?.counterpartyId)
    return Boolean(clientRoutes.find((x) => x === "/" + (path || "").split("/")[1]));

  // Manager — faqat berilgan permission'larga mos sahifalarga kirish
  if (userName === "manager" || (user?.managerId && user?.manager)) {
    const rawSegment = (path || "").split("/")[1];
    if (!rawSegment || rawSegment === "" || rawSegment === "home") {
      return true;
    }
    return Boolean(
      user?.manager?.managerRole?.some(
        (role) => role?.permission?.resourceName?.toLowerCase() === rawSegment.toLowerCase()
      )
    );
  }

  // Administrator, Admin, SuperAdmin, Moderator va barcha boshqaruvchilar uchun — barcha sahifalarga to'liq ruxsat
  return true;
}

